import * as http from '@/util/http'

export type Config = {
  cdnDomain: string
}

export async function fetchSysConfig(): Promise<Config> {
  const { data } = await http.get<Config>('/api/v1/sys')
  return data
}
